var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourcesTable',{attrs:{"table-data":_vm.resources,"endpoint":_vm.endpoint}})}
var staticRenderFns = []

export { render, staticRenderFns }